// extracted by mini-css-extract-plugin
module.exports = {"selector":"selector-37fT8"};